import {
    loadLocalWebPushUserSetting,
    getUserPreferenceIdentifier,
    getLocalWebPushUserSettingStore,
    LocalWebPushUserSetting,
} from 'owa-webpush-notifications';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { getWebPushNotificationsOption } from './getWebPushNotificationsOption';

export function getLocalWebPushUserSetting(): LocalWebPushUserSetting {
    let mbxGuid = getUserConfiguration().SessionSettings.MailboxGuid;
    let userPreferenceIdentifier = getUserPreferenceIdentifier(
        mbxGuid,
        getWebPushNotificationsOption()
    );
    loadLocalWebPushUserSetting(window, userPreferenceIdentifier);
    return getLocalWebPushUserSettingStore();
}
